import util from '../util'

let controller = 'Credito'
export default Object.assign({}, util.GetCrud(controller, null), {
    Cancelar: function (dto) {
        return util.Axios.Post(controller + '/LimiteEspecial/Cancelar', dto)
    },
})
